import socialLinkList from 'data/socialLinks.json';
import { useEffect, useState } from "react";

export function useSocialLinks() {
    const [socialLinks, setSocialLinks] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        try {
            setLoading(true)
            setSocialLinks(socialLinkList)
        } catch (error) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }, [])


    return { socialLinks, loading, error }
}